import { useTranslation } from 'react-i18next';
import { ActionsColumn as ActionsColumnCommon } from '@otp/ui';
import { Checked, Flag } from '@otp/icons';
import React from 'react';
import { NotificationActions } from './types';
import { NotificationPayload } from 'src/graphql/generated/graphql';
import { DocumentNode } from 'graphql';
import { useMarkAsRead } from 'src/hooks/query/notification/use-mark-as-read';
import { useMarkAsUnRead } from 'src/hooks/query/notification/use-mark-as-unread';

type ActionsColumProps = {
  entity: NotificationPayload | Partial<NotificationPayload>;
  refetchDocuments: DocumentNode[];
};

export const ActionsColumn = ({
  entity,
  refetchDocuments,
}: ActionsColumProps) => {
  const { t } = useTranslation();
  const [markAsReadMutation] = useMarkAsRead([entity.id], refetchDocuments);
  const [markAsUnreadMutation] = useMarkAsUnRead([entity.id], refetchDocuments);

  const actions = [
    {
      id: NotificationActions.MarkAsRead,
      label: entity.seenAt
        ? t('notifications.list.mark-as-unread')
        : t('notifications.list.mark-as-read'),
      icon: entity.seenAt ? <Checked /> : <Flag />,
      onClick: () => {
        if (entity.seenAt) {
          markAsUnreadMutation();
        } else {
          markAsReadMutation();
        }
      },
    },
  ];

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <ActionsColumnCommon actions={actions} />
    </div>
  );
};
